// HTML / bundle download (CONTRACTS §10). Single-file docs download the entry
// HTML directly (gated /content fetch); multi-file bundles download a .zip from
// the server (/download), which enumerates the version prefix in Storage.

/** Trigger a browser download for an in-memory Blob. */
function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function safeFilename(name: string): string {
  return (name || "document").replace(/[^\w.-]+/g, "-").replace(/^-+|-+$/g, "");
}

/** Download the entry HTML of a single-file doc, named from its title. */
export async function downloadHtml(
  docId: string,
  versionId: string,
  entry: string,
  title: string
): Promise<void> {
  const res = await fetch(`/content/${docId}/${versionId}/${entry}`, {
    credentials: "same-origin",
  });
  if (!res.ok) {
    throw new Error(
      res.status === 401
        ? "Your session expired — sign in again."
        : `Could not fetch the document (${res.status}).`
    );
  }
  const blob = await res.blob();
  saveBlob(blob, `${safeFilename(title)}.html`);
}

/** Download a multi-file bundle as a .zip (server-assembled, gated). */
export function downloadZip(docId: string, versionId: string): void {
  // The endpoint sets Content-Disposition: attachment, so a same-origin anchor
  // click downloads it with the __session cookie attached.
  const a = document.createElement("a");
  a.href = `/download/${docId}/${versionId}`;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
